<div class="container" *ngIf="notificationBanner">
    <ng-container *ngFor="let notification of notifications">
        <!--CSRH -->
        <div class="alert alert-danger alert-well" *ngIf="notification.id == notificationBannerIdEnum.CustomerResearch">
            <svg class="svg-icon svg-icon--l">
                <use href="assets/icon-love.svg#heart"></use>
            </svg>
            <div>
                <div class="h5">We zijn blij met u. U ook met ons?</div>
                <p>We willen graag weten wat er goed gaat of wat er beter kan!</p>
            </div>
            <div class="alert__buttons">
                <a
                    class="btn btn--secondary"
                    href="https://survey.insocial.nl/swift/?sToken=w9pstr74wz&sId=7554"
                    rel="nofollow noopener"
                    target="_blank"
                >
                    Geef uw eerlijke mening
                </a>
                <button
                    class="btn btn--close notification-banner__close"
                    aria-label="Sluiten"
                    type="button"
                    tabindex="-1"
                    (click)="setClaimYearsCookie(1)"
                >
                    <svg class="svg-icon svg-icon--xs">
                        <use href="assets/icons-ui.svg#cross-closed"></use>
                    </svg>
                </button>
            </div>
        </div>
        <!--CSRH -->

        <!-- SJVD -->
        <div
            class="alert alert-danger alert-well"
            *ngIf="notification.id == notificationBannerIdEnum.ClaimYearsInsuranceCoverage"
        >
            <svg class="svg-icon svg-icon--l">
                <use href="assets/icons-general.svg#privacy"></use>
            </svg>
            <div>
                <div class="h5">Help! Moeten we uw schadevrije jaren aanpassen?</div>
                <p>Dan kan uw premie anders worden!</p>
            </div>
            <div class="alert__buttons">
                <a class="btn btn--secondary" href="/mijn-verzekeringsmap/mijn-schadevrije-jaren/">
                    Dit wil ik meteen oplossen!
                </a>
                <button
                    class="btn btn--close"
                    aria-label="Sluiten"
                    type="button"
                    tabindex="-1"
                    (click)="setClaimYearsCookie(1)"
                >
                    <svg class="svg-icon svg-icon--xs">
                        <use href="assets/icons-ui.svg#cross-closed"></use>
                    </svg>
                </button>
            </div>
        </div>
        <!-- // SJVD -->

        <!-- SJVU-->
        <div
            class="alert alert-danger alert-well"
            *ngIf="notification.id == notificationBannerIdEnum.ClaimYearsInsuranceUpload"
        >
            <svg class="svg-icon svg-icon--l">
                <use href="assets/icons-general.svg#privacy"></use>
            </svg>
            <div>
                <div class="h5">Help! Moeten we uw schadevrije jaren aanpassen?</div>
                <p>We missen nog een document!</p>
            </div>
            <div class="alert__buttons">
                <a class="btn btn--secondary" href="/mijn-verzekeringsmap/mijn-schadevrije-jaren/">
                    Document uploaden!
                </a>
                <button
                    class="btn btn--close"
                    aria-label="Sluiten"
                    type="button"
                    tabindex="-1"
                    (click)="setClaimYearsCookie(1)"
                >
                    <svg class="svg-icon svg-icon--xs">
                        <use href="assets/icons-ui.svg#cross-closed"></use>
                    </svg>
                </button>
            </div>
        </div>
        <!-- // SJVU-->

        <!-- VZKI-->
        <div
            class="alert alert-danger alert-well"
            *ngIf="notification.id === notificationBannerIdEnum.InsuranseStartdate && purchasedProducts.length > 0"
        >
            <svg class="svg-icon svg-icon--l">
                <use href="assets/icons-general.svg#privacy"></use>
            </svg>
            <div>
                <div class="h5">
                    Uw
                    <span *ngFor="let purchasedProduct of purchasedProducts; let last = last; let index = index">
                        <ng-container *ngIf="purchasedProducts.length <= 1">
                            <span class="text-capitalize">{{ purchasedProduct?.product?.productDescription }}</span>
                        </ng-container>
                        <ng-container *ngIf="purchasedProducts.length == 2">
                            <span class="text-capitalize">{{ purchasedProduct?.product?.productDescription }}</span>
                            <span *ngIf="!last">en</span>
                        </ng-container>
                        <ng-container *ngIf="purchasedProducts.length >= 3">
                            <span class="text-capitalize">{{ purchasedProduct?.product?.productDescription }}</span>
                            <span *ngIf="index != purchasedProducts.length - 2 && !last">,</span>
                            <span *ngIf="index == purchasedProducts.length - 2">en</span>
                        </ng-container>
                    </span>
                    <span *ngIf="purchasedProducts.length <= 1">heeft nog geen ingangsdatum.</span>
                    <span *ngIf="purchasedProducts.length > 1">hebben nog geen ingangsdatum.</span>
                </div>
                <p *ngIf="purchasedProducts.length <= 1">
                    De
                    <span *ngFor="let purchasedProduct of purchasedProducts" class="text-capitalize">
                        {{ purchasedProduct?.product?.productDescription }}
                    </span>
                    is nog niet actief!
                </p>
                <p *ngIf="purchasedProducts.length > 1">Deze verzekeringen zijn nog niet actief!</p>
            </div>
            <div class="alert__buttons">
                <button class="btn btn--secondary" (click)="navigateToInsurance()">Vul nu de ingangsdatum in!</button>
                <button
                    class="btn btn--close"
                    type="button"
                    aria-label="Sluiten"
                    tabindex="-1"
                    (click)="setClaimYearsCookie(1)"
                >
                    <svg class="svg-icon svg-icon--xs">
                        <use href="assets/icons-ui.svg#cross-closed"></use>
                    </svg>
                </button>
            </div>
        </div>
        <!-- // VZKI-->
    </ng-container>
</div>
